import { refreshPage } from '../actions/refreshPage';
import { SESSION_FORCED_CAMPAIGNS } from '../constants';

export enum ForceTestTargetingAction {
  FORCE_ACCEPTED = 'force_accepted',
  FORCE_REJECTED = 'force_rejected',
  FORCE_RESET = 'reset',
}

const forceTestTargetingActionSessionValue = {
  [ForceTestTargetingAction.FORCE_ACCEPTED]: 1 as const,
  [ForceTestTargetingAction.FORCE_REJECTED]: 0 as const,
};

type SessionForceTestTargetingActionValue =
  (typeof forceTestTargetingActionSessionValue)[keyof typeof forceTestTargetingActionSessionValue];
type SessionForceTestTargeting = Record<number, SessionForceTestTargetingActionValue>;

const storage = {
  get: (): SessionForceTestTargeting => {
    try {
      return JSON.parse(window.sessionStorage.getItem(SESSION_FORCED_CAMPAIGNS) ?? '{}');
    } catch (e) {
      console.error(`${SESSION_FORCED_CAMPAIGNS} session storage key is corrupted (${e})`);
    }
    return {};
  },
  set: (value: SessionForceTestTargeting): boolean => {
    try {
      window.sessionStorage.setItem(SESSION_FORCED_CAMPAIGNS, JSON.stringify(value));
      return true;
    } catch (e) {
      console.error(`Can't persist value ${value} into ${SESSION_FORCED_CAMPAIGNS} session storage key (${e})`);
    }
    return false;
  },
  clear: () => {
    try {
      window.sessionStorage.removeItem(SESSION_FORCED_CAMPAIGNS);
      return true;
    } catch (e) {
      console.error(`Can't remove session storage key ${SESSION_FORCED_CAMPAIGNS} (${e})`);
    }
    return false;
  },
};

export function forceTestTargeting(testId: number, action: ForceTestTargetingAction) {
  const forcedTestTargeting = storage.get();

  let reload = false;
  switch (action) {
    case ForceTestTargetingAction.FORCE_RESET:
      if (testId in forcedTestTargeting) {
        delete forcedTestTargeting[testId];
        Object.keys(forcedTestTargeting).length ? storage.set(forcedTestTargeting) : storage.clear();
        reload = true;
      }
      break;
    case ForceTestTargetingAction.FORCE_ACCEPTED:
    case ForceTestTargetingAction.FORCE_REJECTED:
      reload = storage.set({
        ...forcedTestTargeting,
        [testId]: forceTestTargetingActionSessionValue[action],
      });
      break;
  }
  reload && refreshPage();
}
